"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLoginDto = void 0;
const misc_1 = require("../../../misc");
const user_1 = require("../user");
class UserLoginDto extends (0, misc_1.generateCreateDto)(user_1.User, ['mobile']) {
}
exports.UserLoginDto = UserLoginDto;
